<script setup>
import {computed} from "vue";

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean, Object],
    required: true,
  },
  id: {
    type: [String, Number],
    required: true,
  },
  name: {
    type: [String, Number],
    required: true,
  },
  trueValue: {
    type: [String, Number, Boolean, Object],
    default: true
  },
})

const emit = defineEmits(['update:modelValue']);

const isSelected = computed(() => JSON.stringify(props.modelValue) === JSON.stringify(props.trueValue));

</script>

<template>
  <label
    class="tw-relative tw-flex tw-items-center tw-cursor-pointer"
    :for="id"
  >
    <input
      :id="id"
      :name="name"
      type="radio"
      :checked="isSelected"
      class="tw-hidden"
      @input="emit('update:modelValue', trueValue)"
    >

    <div
      class="tw-border tw-w-5 tw-h-5 tw-rounded-full tw-transition-all tw-duration-300 tw-p-[1px]"
      :class="{
        'tw-border-primary-100 tw-bg-white': isSelected,
        'tw-border-neutral-400 tw-bg-neutral-100': !isSelected
      }"
    >
      <div
        v-show="isSelected"
        class="tw-rounded-full tw-w-full tw-h-full tw-border-[.35em] tw-border-primary-300 tw-transition-all tw-duration-300"
      />
    </div>

    <slot />
  </label>
</template>
